__turbopack_context__.v({
  "root": "MYRw2a_root",
  "rotate": "MYRw2a_rotate",
});
